import createAPIRequestId from '../helpers/createAPIRequestId'
import hasTempId from '../helpers/hasTempId'
import store from '../store/index'
//---------------------
// edit character spell
//---------------------
export default async function useEditCharacterSpell(spell, { preview = false } = {}) {
  console.log('-------------------------------------')
  console.log('IN useEditCharacterSpell....')
  console.log('spell:', spell)
  //--------------
  // access store
  //--------------
  const this_store = store
  //--------------------
  // set api call parms
  //--------------------
  let parm_id = ''
  let parm_partialInd = false
  const hasPersistedId =
    spell.id !== undefined && spell.id !== null && spell.id !== '' && !hasTempId(spell.id)

  if (hasPersistedId) {
    parm_id = spell.id
    parm_partialInd = spell.action !== 'DELETE' ? true : false
  }
  //---------------------------------------------
  // declare request parms to create api request
  //--------------------------------------------
  // route to the correct spell endpoint based on source type
  const spellType = (spell.type || '').toString().toLowerCase()
  let endpoint = 'api/v1/character-spells/'

  if (spellType === 'item') {
    endpoint = 'api/v1/character-item-spells/'
  } else if (spellType === 'rune') {
    endpoint = 'api/v1/character-rune-spells/'
  }
  //
  let request_parms = {
    endpoint: preview ? endpoint + '?preview=true' : endpoint,
    partialInd: parm_partialInd,
    id: parm_id,
  }
  //---------------------------------------------------
  // where DELETE add indicator for create api request
  //---------------------------------------------------
  if (spell.action === 'DELETE') {
    request_parms.deleteInd = true
  }
  //--------------------------
  // create api request by id
  //--------------------------
  let request = createAPIRequestId(request_parms)
  //---------------
  // set api parms
  //---------------
  let api_parms = {
    api_request: request,
    api_preview: preview,
  }
  //----------------------------------
  // include payload where not DELETE
  //----------------------------------
  if (spell.action !== 'DELETE') {
    api_parms.payload = spell.payload
  }
  console.log('api_parms = ', api_parms)
  //-------------------------------------------------------------------------
  // - return the dispatch Promise in all cases
  // - preview callers will await this and receive the response
  // - non-preview callers can ignore the returned Promise (fire-and-forget)
  //-------------------------------------------------------------------------
  return this_store
    .dispatch('characters/editCharacterSpell', api_parms)
    .then((res) => {
      // optional: log preview response
      if (preview) console.log('useEditCharacterSpell preview result:', res)
      return res
    })
    .catch((err) => {
      if (err?.response?.status === 404 && spell.action === 'DELETE') {
        console.warn(
          'CharacterSpell already deleted; treating DELETE as successful for spell =',
          spell.name,
        )

        return {
          data: null,
          status: 204,
          statusText: 'No Content',
        }
      }

      console.error('editCharacterSpell error:', err)
      // rethrow so callers awaiting this will receive the rejection
      throw err
    })
}
